import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';
import {useNavigate} from "react-router-dom";

// Styled button with subtle gradient
const SubtleGradientButton = styled(Button)(({theme}) => ({
    background: 'linear-gradient(45deg, #00a3b1 30%, #0093e9 50%, #6e00b7 90%)',
    borderRadius: 10,
    color: 'white',
    padding: '10px 30px',
    boxShadow: '0 3px 5px 2px rgba(110, 0, 183, 0.3)',
    fontSize: '16px',
    '&:hover': {
        background: 'linear-gradient(45deg, #6e00b7 30%, #0093e9 70%, #00a3b1 100%)',
    },
}));

const NormalTextTypography = styled(Typography)(({theme}) => ({
    color: '#e0e0e0', // Normal text color
    fontSize: '1.2rem',
    textAlign: 'center',
}));

const IllustrationBox = styled(Box)(({theme}) => ({
    marginBottom: '20px',
    '& img': {
        width: '100%', // Adjust size as needed
        height: 'auto',
    },
}));

const SessionStatus = ({todayMeetingMetadata, handleStartMeeting}) => {
    const navigate = useNavigate();

    const navigateToChat = (sessionId) => {
        navigate(`/chat/${sessionId}`, {replace: true});
    }

    const renderMeetingStatus = (illustration, text, button) => {
        return (
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
                height: '100%',
                textAlign: 'center',
                gap: '20px',
                direction: 'rtl',
            }}>
                {/* Illustration */}
                <IllustrationBox>
                    <img src={illustration} alt="illustration"/>
                </IllustrationBox>

                {/* Text */}
                <NormalTextTypography variant="body1">
                    {text}
                </NormalTextTypography>

                {/* Button */}
                {button}
            </Box>
        );
    };

    return (
        <Box sx={{
            flexGrow: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60vh',
            textAlign: 'center',
            padding: '0 20px',
        }}>
            {/* Conditionally render based on the status of today's meeting */}
            {todayMeetingMetadata?.startTime && !todayMeetingMetadata?.endTime &&
                renderMeetingStatus(
                    "illu-ongoing-session.png",  // Placeholder illustration path for ongoing session
                    "היי, הפגישה היומית שלנו כבר התחילה",
                    <SubtleGradientButton variant="contained"
                                          onClick={() => navigateToChat(todayMeetingMetadata.sessionId)}>
                        היכנס לפגישה
                    </SubtleGradientButton>
                )}
            {!todayMeetingMetadata &&
                renderMeetingStatus(
                    "illu-start-session.png",  // Placeholder illustration path for not started session
                    "נראה שעדיין לא התחלת את השיחה היומית שלך",
                    <SubtleGradientButton variant="contained" onClick={handleStartMeeting}>
                        התחל את הפגישה היומית שלנו
                    </SubtleGradientButton>
                )}
            {todayMeetingMetadata?.startTime && todayMeetingMetadata?.endTime &&
                renderMeetingStatus(
                    "illu-end-session.png",  // Placeholder illustration path for completed session
                    `הפגישה היומית שלנו הסתיימה (${new Date(todayMeetingMetadata.endTime).toLocaleTimeString('he-IL')})`,
                    <NormalTextTypography variant="h5" sx={{color: '#b4b3b3', textAlign: 'center'}}>
                        {`נתראה בפגישה הבאה שלנו מחר`}
                    </NormalTextTypography>
                )}
        </Box>
    );
};

export default SessionStatus;
